import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Login from './components/authentification/Login.js';
import Logout from './components/authentification/Logout.js'
import Home from './components/home/Home.js';
import PrivateRoutes from './auth/PrivateRoutes.js';
import ManagerUGUser from './components/managerUG/ManagerUGUser.js'
import ManagerINTUser from './components/managerINT/ManagerINTUser.js'
import CreerUG from './components/managerUG/CreerUG.js';
import ModifierUG from './components/managerUG/ModifierUG.js'
import CreerINT from './components/managerINT/CreerINT.js'
import ModifierINT from './components/managerINT/ModifierINT.js'
import CreerUtilisateur from './components/managerUtilisateur/CreerUtilisateur.js'
import ModifierUtilisateur from './components/managerUtilisateur/ModifierUtilisateur.js'
import EstimerContrat from './components/contrats/estimerContrat/EstimerContrat.js';
import AjouterContrat from './components/contrats/ajouterContrat/AjouterContrat.js';
import ConsulterContrat from './components/contrats/consulterContrat/ConsulterContrat.js'
import RechercherContrat from './components/contrats/rechercheContrat/RechercherContrat.js'
import ChangePassword from './components/authentification/ChangePassword.js'
import InformationUtilisateur from './components/user/InformationUtilisateur.js';
import NotFound from './components/error/NotFound.js';
import Unauthorized from './components/error/Unauthorized.js'
import Documentation from './components/docs/Documentations.js';
import './index.css';

const App = () => {

  return (

    <Routes>
      {/* ROUTE AUTHENTIFICATION*/}
      <Route path="/login" element={<Login />} />
      <Route path="/change-password" element={<ChangePassword />} />
      <Route path='/logout' element={<Logout />} />

      { /* ROUTE PRIVEE*/}
      <Route path='/' element={<PrivateRoutes><Home /></PrivateRoutes>} />
      <Route path='/admin/creer-ug' element={<PrivateRoutes><CreerUG/></PrivateRoutes>} />
      <Route path='/admin/modifier-ug' element={<PrivateRoutes><ModifierUG/></PrivateRoutes>} />
      <Route path='/admin/creer-int' element={<PrivateRoutes><CreerINT/></PrivateRoutes>} />
      <Route path='/admin/modifier-int' element={<PrivateRoutes><ModifierINT/></PrivateRoutes>} />
      <Route path='/admin/creer-utilisateur' element={<PrivateRoutes><CreerUtilisateur/></PrivateRoutes>} />
      <Route path='/admin/modifier-utilisateur' element={<PrivateRoutes><ModifierUtilisateur/></PrivateRoutes>} />
      
      <Route path='/manager-ug' element={<PrivateRoutes><ManagerUGUser/></PrivateRoutes>} />
      <Route path='/manager-int' element={<PrivateRoutes><ManagerINTUser/></PrivateRoutes>} />

      <Route path='/contrat/estimer-contrat' element={<PrivateRoutes><EstimerContrat/></PrivateRoutes>} />
      <Route path='/contrat/ajouter-contrat' element={<PrivateRoutes><AjouterContrat/></PrivateRoutes>} />
      <Route path='/contrat/consulter-contrat/:zone' element={<PrivateRoutes><ConsulterContrat/></PrivateRoutes>} />
      <Route path='/contrat/rechercher-contrat' element={<PrivateRoutes><RechercherContrat/></PrivateRoutes>} />

      <Route path='/user/information' element={<PrivateRoutes><InformationUtilisateur/></PrivateRoutes>} />

      <Route path='/documentations' element={<PrivateRoutes><Documentation/></PrivateRoutes>} />

      { /* ROUTE ERREUR */}
      <Route path="/unauthorized" element={<Unauthorized />} />
      <Route path="*" element={<NotFound />} />

    </Routes>
  )
}

export default App
